import 'immer'
import type { ZMiddlewares } from './middlewares'
import type { GlobalSlice, GlobalStateType } from './types'
import type {
  NodeValidateType,
} from 'src/types'
import type { StateCreator } from 'zustand'

export const DEFAULT_NODE_VALIDATE: NodeValidateType = {
  nodeId: -1,
  status: 'pass', // pass,warning,error
  validMessage: '',
}

export const globalState: GlobalStateType = {
  // env: 'dev',
  // rawData: undefined,
  saveStatus: false,
  // activeNodeId: '',
  // modifyName: {
  //   nodeId: undefined,
  //   nodeName: '',
  // },
  // nodeValidates: [{ ...DEFAULT_NODE_VALIDATE }],
  isInit: true,
  isLock: false,
}

export const createGlobalSlice: StateCreator<GlobalSlice, ZMiddlewares> = (
  set,
): GlobalSlice => ({
  ...globalState,
  setData(data) {
    set((state) => {
      return { ...state, ...data }
    })
  },
  setModel(model) {
    set((state) => {
      state.model = model
    })
  },
  setInitState(isInit) {
    set((state) => {
      state.isInit = isInit
    })
  },
  setRawData(rawData) {
    set((state) => {
      state.rawData = rawData
    })
  },
  setSaveStatus(saveStatus) {
    set((state) => {
      state.saveStatus = saveStatus
    })
  },
  setActiveNode(activeNodeId) {
    set((state) => {
      state.activeNodeId = activeNodeId
    })
  },
  setModifyName(modifyName) {
    set((state) => {
      state.modifyName = modifyName
    })
  },
  setNodeValidates(nodeValidates) {
    set((state) => {
      state.nodeValidates = nodeValidates
    })
  },
  setIsLock(isLock) {
    set((state) => {
      state.isLock = isLock
    })
  },
})

// export default function createGlobalStore() {
//   const useGlobalBaseStore = createStore<GlobalStateType>()(
//     zustandMiddlewares(() => globalState),
//   )

//   // useGlobalBaseStore.
//   // const useGlobalStore = createSelectors(useGlobalBaseStore)

//   // return {
//   //   useGlobalBaseStore,
//   //   // useGlobalStore,
//   // }

//   return createStore<GlobalStateType>()(zustandMiddlewares(() => globalState))
// }

// export const useGlobalBaseStore = create<GlobalStateType>()(
//   zustandMiddlewares(() => globalState),
// )

// export const useGlobalStore = createSelectors(useGlobalBaseStore)

// export const setData = (data: Partial<GlobalStateType>) => {
//   useGlobalStore.setState((state) => {
//     return { ...state, ...data }
//   })
// }

// export const setModel = (model: ModelType) => {
//   useGlobalStore.setState((state) => {
//     state.model = model
//   })
// }

// export const setInitState = (isInit: boolean) => {
//   useGlobalStore.setState((state) => {
//     state.isInit = isInit
//   })
// }

// // export const setEnv = (env: EnvType) => {
// //   useGlobalStore.setState((state) => {
// //     state.env = env;
// //   });
// // };

// export const setRawData = (rawData?: RawData) => {
//   useGlobalStore.setState((state) => {
//     state.rawData = rawData
//   })
// }

// export const setSaveStatus = (saveStatus: boolean) => {
//   useGlobalStore.setState((state) => {
//     state.saveStatus = saveStatus
//   })
// }

// export const setActiveNode = (activeNodeId?: string) => {
//   useGlobalStore.setState((state) => {
//     state.activeNodeId = activeNodeId
//   })
// }

// export const setModifyName = (modifyName?: ModifyNameType) => {
//   useGlobalStore.setState((state) => {
//     state.modifyName = modifyName
//   })
// }

// export const setNodeValidates = (nodeValidates?: NodeValidateType[]) => {
//   useGlobalStore.setState((state) => {
//     state.nodeValidates = nodeValidates
//   })
// }

// export const setIsLock = (isLock: boolean) => {
//   useGlobalStore.setState((state) => {
//     state.isLock = isLock
//   })
// }
